import * as React from 'react';

const SvgArrowRight = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 9 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m.91 16.92 6.52-6.52c.77-.77.77-2.03 0-2.8L.91 1.08"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgArrowRight;
